import type { AnimeSubject, SubjectPage } from '../types/bgm';

type BgmRequest = <T>(path: string, init?: RequestInit) => Promise<T>;

export const loadPopularSubjects = async (
  bgm: BgmRequest,
  options: { japaneseAnimeOnly: boolean; showNsfw: boolean },
): Promise<AnimeSubject[]> => {
  const from = new Date();
  from.setMonth(from.getMonth() - 6);
  const payload = {
    keyword: '',
    sort: 'heat',
    filter: {
      type: [2],
      air_date: [`>=${from.toISOString().slice(0, 10)}`, `<=${new Date().toISOString().slice(0, 10)}`],
      rating: ['>7'],
      rating_count: ['>=300'],
      ...(options.japaneseAnimeOnly ? { tag: ['日本'] } : {}),
      ...(!options.showNsfw ? { nsfw: false } : {}),
    },
  };
  const fetchPage = (offset: number) =>
    bgm<SubjectPage>(`/v0/search/subjects?limit=20&offset=${offset}`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  const first = await fetchPage(0);
  const pages = await Promise.all(
    Array.from({ length: Math.max(0, Math.ceil(first.total / 20) - 1) }, (_, page) => fetchPage((page + 1) * 20)),
  );
  return [first, ...pages]
    .flatMap((page) => page.data)
    .sort((left, right) => (Date.parse(right.date ?? '') || 0) - (Date.parse(left.date ?? '') || 0))
    .slice(0, 10);
};
